export default __webpack_public_path__ + "static/media/WomenCentre.410ff81c.png";